/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import {
	productDetailsNameSX,
	familyDetailsSX,
} from '@/components/blocks/ProductDetails/styles/name';
import { useProductDetails } from '@/data/Content/ProductDetails';
import { useSkuListTable } from '@/data/Content/SkuListTable';
import { ContentContext } from '@/data/context/content';
import { getProductDisplayInfo } from '@/utils/getProductDisplayInfo';
import { isKitOrBundleType } from '@/utils/productIsA';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC, useContext } from 'react';

export const ProductDetailsDisplay: FC<{ isElectronic?: boolean }> = ({ isElectronic }) => {
	const { selection, product } = useContext(ContentContext) as ReturnType<
		typeof useProductDetails
	> &
		ReturnType<typeof useSkuListTable>;
	const isKitOrBundle = isKitOrBundleType[product?.type ?? 'unknown'];
	const sku = !isKitOrBundle ? selection?.sku : product;
	const { name, tabsData } = getProductDisplayInfo(sku, product);
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const familyAttr = tabsData.descriptiveAttributes.find((elm) => elm.identifier === 'Familia');
	const genderAttr = tabsData.descriptiveAttributes.find((elm) => elm.identifier === 'Genero');

	return (
		<Stack>
			{!isMobile ? (
				<Box component={'span'} sx={familyDetailsSX}>
					{isElectronic
						? 'Electrónicos'
						: `${familyAttr?.values[0].value} ${genderAttr?.values[0].value}`}
				</Box>
			) : null}
			{name ? (
				<Typography variant="h4AsH1" sx={productDetailsNameSX}>
					{name}
				</Typography>
			) : null}
			{/* {!isKitOrBundle && partNumber ? (
				<Typography variant="overline">{localization.skuLabel.t({ value: partNumber })}</Typography>
			) : null}
			{short ? <Typography variant="body1AsH2">{short}</Typography> : null} */}
		</Stack>
	);
};
